import React from "react";
import { useState } from "react";
import { noDataFound } from "../../../CommonMethhods/CommonMethods";

function AnalyticsStock(props) {
  const stock = props.stock;

  const showStockData = () => {
    return (
      stock &&
      stock.map((item, index, key) => {
        return (
          <>
            <tr key={key}>
              <td>
                <span>{index + 1}. </span>
                {item.compnayName === undefined || null
                  ? "-"
                  : item.compnayName}
              </td>
              <td>
                {item.per === undefined || null ? "-" : item.per.toFixed(2)}%
              </td>
            </tr>
          </>
        );
      })
    );
  };
  return (
    <div className="analytic-table">
      {stock && stock ? (
        <table className="table">
          <tbody>{showStockData()}</tbody>
        </table>
      ) : (
        noDataFound()
      )}
    </div>
  );
}

export default AnalyticsStock;
